"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _contains = _interopRequireDefault(require("lodash/fp/contains"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _negate = _interopRequireDefault(require("lodash/fp/negate"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _itemVisitUtils = require("../Menu/itemVisitUtils");
var _DropdownPresenter2 = _interopRequireDefault(require("./DropdownPresenter"));
var _ReservedOptions = require("./ReservedOptions");
var _LabelDropdownButton = _interopRequireDefault(require("./LabelDropdownButton"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MultiSelectionPresenter = exports["default"] = /*#__PURE__*/function (_DropdownPresenter) {
  function MultiSelectionPresenter() {
    (0, _classCallCheck2["default"])(this, MultiSelectionPresenter);
    return _callSuper(this, MultiSelectionPresenter, arguments);
  }
  (0, _inherits2["default"])(MultiSelectionPresenter, _DropdownPresenter);
  return (0, _createClass2["default"])(MultiSelectionPresenter, [{
    key: "DropdownButton",
    get: function get() {
      return _LabelDropdownButton["default"];
    }
  }, {
    key: "emitValue",
    value: function emitValue(valueSelected, prevValue, children) {
      return (0, _contains["default"])(valueSelected)(prevValue) || valueSelected === _ReservedOptions.ReservedOptions.All && this.isAllItemSelected(prevValue, children) ? this.removeFromValue(valueSelected, prevValue) : this.addToValue(valueSelected, prevValue, children);
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(_, children) {
      return children;
    }
  }, {
    key: "addToValue",
    value: function addToValue(valueSelected, prevValue, children) {
      if (valueSelected === _ReservedOptions.ReservedOptions.All) {
        return (0, _compose["default"])((0, _filter["default"])((0, _negate["default"])((0, _eq["default"])(_ReservedOptions.ReservedOptions.All))), (0, _map["default"])((0, _prop["default"])('props.value')), this.flattenOptions)(children);
      }
      if (prevValue) {
        return (0, _contains["default"])(valueSelected)(prevValue) ? prevValue : prevValue.concat([valueSelected]);
      }
      return [valueSelected];
    }
  }, {
    key: "removeFromValue",
    value: function removeFromValue(valueSelected, prevValue) {
      var result = valueSelected === _ReservedOptions.ReservedOptions.All ? null : (0, _filter["default"])((0, _negate["default"])((0, _eq["default"])(valueSelected)))(prevValue);
      return (result === null || result === void 0 ? void 0 : result.length) === 0 ? null : result;
    }
  }, {
    key: "menuCollapseBehavior",
    get: function get() {
      return 'escape';
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(itemValue, value, children) {
      var _value$indexOf;
      if (itemValue === _ReservedOptions.ReservedOptions.All) {
        return this.isAllItemSelected(value, children);
      }
      return ((_value$indexOf = value === null || value === void 0 ? void 0 : value.indexOf(itemValue)) !== null && _value$indexOf !== void 0 ? _value$indexOf : -1) >= 0;
    }
  }, {
    key: "isAllItemSelected",
    value: function isAllItemSelected(value, children) {
      return !!value && value.length > 0 && (0, _compose["default"])(function (noneSelecteds) {
        return noneSelecteds.length === 0;
      }, (0, _filter["default"])(function (itemValue) {
        return (value === null || value === void 0 ? void 0 : value.indexOf(itemValue)) < 0 && itemValue !== _ReservedOptions.ReservedOptions.All;
      }))(this.getAllOptionValues(children));
    }
  }, {
    key: "getAllOptionValues",
    value: function getAllOptionValues(children) {
      return (0, _compose["default"])((0, _filter["default"])(function (itemValue) {
        return !(0, _contains["default"])(itemValue)([_ReservedOptions.ReservedOptions.All]);
      }), _itemVisitUtils.getAllItemValues)(children);
    }
  }, {
    key: "renderDefaultLabel",
    value: function renderDefaultLabel(value, children) {
      if (!this.hasValue(value)) {
        return '';
      }
      if (this.isSingleItemSelected(value, children)) {
        return this.calculateLabelOf((0, _first["default"])(value))(_react["default"].Children.toArray(children));
      }
      return this.isAllItemSelected(value, children) ? this.i18n('react-ui.common.dropdown.label.multi.all.selected') : this.i18n('react-ui.common.dropdown.label.multi.selected', {
        count: "".concat(value.length)
      });
    }
  }, {
    key: "isSingleItemSelected",
    value: function isSingleItemSelected(value, children) {
      return value.length === 1 && this.getAllOptionValues(children).length > 1;
    }
  }]);
}(_DropdownPresenter2["default"]);